<template>
  <div>
    <div v-if="hasPaginationFilter">
      <label class="tb-label">
        Current Page
      </label>

      <div class="data-list__page-controls">
        <button
          class="tb-btn tb-btn-contained medium-em"
          :disabled="pagination.page <= 1"
          data-entity="producer-editor-pageBack"
          @click="incrementPage(-1)"
        >
          <span class="fas fa-backward" />
        </button>

        <input
          type="number"
          :min="1"
          v-model.number="pagination.page"
          class="tb-input flex-grow margin-left-md margin-right-md page-input"
          data-entity="producer-editor-setPage"
        />

        <button
          class="tb-btn tb-btn-contained medium-em"
          data-entity="producer-editor-pageForward"
          @click="incrementPage(1)"
        >
          <span class="fas fa-forward" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    element: {
      type: Object,
      required: true,
    },
  },

  computed: {
    filters() {
      return this.element?.data?.filters || [];
    },

    hasPaginationFilter() {
      return !!this.filters.find((f) => f.type === 'pagination');
    },

    pagination() {
      return this.filters.find((filter) => filter.type === 'pagination');
    },
  },

  methods: {
    incrementPage(amount) {
      const { filters } = this;
      const pagination = filters.find((f) => f.type === 'pagination');
      pagination.page += amount;

      this.$emit('value', {
        value: filters,
        field: 'data.filters',
      });
    },
  },
};
</script>
